import { render } from "./ThemePicker.vue?vue&type=template&id=4fac5b4e&scoped=true"
import script from "./ThemePicker.vue?vue&type=script&lang=js"
export * from "./ThemePicker.vue?vue&type=script&lang=js"

import "./ThemePicker.vue?vue&type=style&index=0&id=4fac5b4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fac5b4e"]])

export default __exports__